import { Component, OnInit } from '@angular/core';
import { StatService } from '../../services/stat.service';
import { ToasterService } from 'angular2-toaster';

@Component({
  selector: 'app-stat-manager',
  templateUrl: './stat-manager.component.html',
  styleUrls: ['./stat-manager.component.css']
})
export class StatManagerComponent implements OnInit {
  tags = [
    'genres',
    'frame_rates',
    'types',
    'resolutions',
    'styles'
  ];
  selectedTag = this.tags[0];
  stats;

  constructor(
    private statService: StatService,
    private toasterService: ToasterService
  ) { }

  ngOnInit() {
    this.stats = this.statService.stats;
  }

  add(tag, type) {
    this.statService.add(tag, type).subscribe(tag => {

    });
  }

  delete(tag, index: number, type) {
    this.statService.delete(tag.id, index, type).subscribe(() => {
      this.stats = this.statService.stats;
      this.toasterService.pop('success', 'Success', 'Tag deleted');
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/components/stat-manager/stat-manager.component.ts